module.exports = {
    messages: {
        de: {
            WBA_085: {
                pageDescriptions: {
                    p005: "Seitenmaße (Breite × Höhe): 14,4 × 22,4 cm."
                }
            },
            WBA_110: {
                pageDescriptions: {
                    p5: "Seitenmaße (Breite × Höhe): 13,6 × 10,5 cm."
                }
            },
            WBA_157: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 22 × 28,5 cm."
                }
            },
            WBA_206: {
                pageDescriptions: {
                    p2: "Seitenmaße (Breite × Höhe): 14,9 × 11,4 cm.",
                    p3: "Seitenmaße (Breite × Höhe): 13,6 × 10,5 cm."
                }
            },
            WBA_208: {
                description: "Seitenmaße (Breite × Höhe): 7,9 × 4,7 cm."
            },
            WBA_209: {
                description: "Die Adreßkartei besteht aus 11 Karten und einem Zettel im Format von etwa 14,8 × 10,5 cm (Postkarten, gedruckten Mitteilungen, einer Einladung, einer Speisekarte), auf deren Rückseite Benjamin Namen, Adressen und Telefonnummern notierte."
            },
            WBA_272: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 6,8 × 10,5 cm.",
                    p2: "Seitenmaße (Breite × Höhe): 9,4 × 11,7 cm.",
                    p3: "Seitenmaße (Breite × Höhe): 10,4 × 13,5 cm."
                }
            },
            WBA_290: {
                pageDescriptions: {
                    p3: "Seitenmaße (Breite × Höhe): 13,2 × 17,2 cm."
                }
            },
            WBA_359: {
                description: "Seitenmaße (Breite × Höhe): 11,6 × 8 cm."
            },
            WBA_363: {
                description: `Seitenmaße (Breite × Höhe, Konvolut): 19,8-20,9 × 27,2-27,3 cm.`,
                pageDescriptions: {
                    p033: "Seitenmaße (Breite × Höhe, aktuelle Seite): 14 × 22,4 cm.",
                    p034: "Seitenmaße (Breite × Höhe, aktuelle Seite): 14 × 22,4 cm.",
                    p035: "Seitenmaße (Breite × Höhe, aktuelle Seite): 11,3 × 18 cm."
                }
            },
            WBA_369: {
                description: `Seitenbreite: 17,9 cm, Seitenhöhe: 20,9 cm.`
            },
            WBA_370: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 13,6 × 21,4 cm.",
                    p2: "Seitenmaße (Breite × Höhe): 13,5 × 20,8 cm.",
                    p3: "Seitenmaße (Breite × Höhe): 13,5 × 20,8 cm.",
                    p4: "Seitenmaße (Breite × Höhe): 13,5 × 20,8 cm.",
                    p5: "Seitenmaße (Breite × Höhe): 13,5 × 20,8 cm."
                }
            },
            WBA_371: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 12,9 × 17,2 cm.",
                    p2: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p3: "Seitenmaße (Breite × Höhe): 27 × 21 cm.",
                    p5: "Seitenmaße (Breite × Höhe): 10,5 × 13,7 cm.",
                    p6: "Seitenmaße (Breite × Höhe): 13,8 × 22,4 cm.",
                    p7: "Seitenmaße (Breite × Höhe): 13,8 × 22,4 cm.",
                    p8: "Seitenmaße (Breite × Höhe): 13,8 × 22,4 cm.",
                    p9: "Seitenmaße (Breite × Höhe): 13,6 × 21,1 cm.",
                    p10: "Seitenmaße (Breite × Höhe): 13,8 × 22,4 cm.",
                    p11: "Seitenmaße (Breite × Höhe): 13,5 × 9 cm.",
                    p12: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p14: "Seitenmaße (Breite × Höhe): 7,2 × 10,3 cm.",
                    p15: "Seitenmaße (Breite × Höhe): 7,2 × 10,3 cm.",
                    p16: "Seitenmaße (Breite × Höhe): 8 × 11,5 cm.",
                    p17: "Seitenmaße (Breite × Höhe): 13,5 × 20,8 cm.",
                    p18: "Seitenmaße (Breite × Höhe): 13,3 × 17,2 cm.",
                    p19: "Seitenmaße (Breite × Höhe): 13 × 17,2 cm.",
                    p20: "Seitenmaße (Breite × Höhe): 30,8 × 20,9 cm.",
                    p21: "Seitenmaße (Breite × Höhe): 30,8 × 20,9 cm."
                }
            },
            WBA_372: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p2: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p3: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p4: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p5: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p6: "Seitenmaße (Breite × Höhe): 8 × 11,2 cm.",
                    p7: "Seitenmaße (Breite × Höhe): 13,6 × 21 cm.",
                    p8: "Seitenmaße (Breite × Höhe): 12,8 × 17,2 cm.",
                    p10: "Seitenmaße (Breite × Höhe): 10,4 × 14,8 cm.",
                    p11: "Seitenmaße (Breite × Höhe): 13,4 × 20,9 cm.",
                    p12: "Seitenmaße (Breite × Höhe): 13,7 × 20,8 cm."
                }
            },
            WBA_373: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 15,5 × 14,5 cm.",
                    p2: "Seitenmaße (Breite × Höhe): 17,2 × 26,6 cm.",
                    p3: "Seitenmaße (Breite × Höhe): 10,4 × 14,4 cm.",
                    p5: "Seitenmaße (Breite × Höhe): 10,6 × 13,7 cm.",
                    p4: "Seitenmaße (Breite × Höhe): 12,8 × 17,2 cm."
                }
            },
            WBA_398: {
                description: `Das braune Lederheft ist auf 60 sehr durchscheinenden beigen Blättern im Format 10×15,5 cm mit dem Text „Berliner Chronik“ beschrieben.
                    Die Blätter sind, größtenteils nur auf der Vorderseite, eng mit schwarzer Tinte beschrieben, die stellenweise stark verblaßt ist. In dem Lederheft
                    befindet sich zudem der Text „Spanien 1932“, der auf der letzten Seite des umgedrehten Hefts begonnen wurde, so daß beide Texte auf die Heftmitte
                    zulaufen.<br/><br/>Seitenmaße: Höhe mit Kantenüberstand 17,2 cm, Höhe ohne Kantenüberstand 15,5 cm, Breite mit Kantenüberstand 11,3 cm, Breite ohne
                    Kantenüberstand 10 cm.`
            },
            WBA_401: {
                pageDescriptions: {
                    p18: "Seitenmaße (Breite × Höhe): 9 × 12 cm."
                }
            },
            WBA_433: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 10,5 × 13,6 cm."
                }
            },
            WBA_524: {
                pageDescriptions: {
                    p29: "Seitenmaße (Breite × Höhe): 13,6 × 21 cm."
                }
            },
            WBA_973: {
                pageDescriptions: {
                    p1: "Seitenmaße (Breite × Höhe): 13,6 × 21,5 cm."
                }
            },
            WBA_BK_Stefan: {
                description: "Seitenmaße (Breite × Höhe, Konvolut): 19,6–21 × 27,2-27,4 cm.",
                pageDescriptions: {
                    p04: "Seitenmaße (Breite × Höhe, aktuelle Seite): 14,2 × 27,2 cm.",
                    p15: "Seitenmaße (Breite × Höhe, aktuelle Seite): 17,7 × 27,2 cm."
                }
            },
            metadata: {
                detailsReference: "Detaillierte Angaben zum Überlieferungs­träger s. Buchausgabe „Zur Edition”.",
                metadata: "Metadaten",
                notAvailable: "Keine Metadaten für die aktuell gezeigte Seite verfügbar."
            }
        },
        en: {
            WBA_085: {
                pageDescriptions: {
                    p005: "Page dimensions (width × height): 14.4 × 22.4 cm."
                }
            },
            WBA_110: {
                pageDescriptions: {
                    p5: "Page dimensions (width × height): 13.6 × 10.5 cm."
                }
            },
            WBA_157: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 22 × 28.5 cm."
                }
            },
            WBA_206: {
                pageDescriptions: {
                    p2: "Page dimensions (width × height): 14.9 × 11.4 cm.",
                    p3: "Page dimensions (width × height): 13.6 × 10.5 cm."
                }
            },
            WBA_208: {
                description: "Page dimensions (width × height): 7,9 × 4,7 cm."
            },
            WBA_209: {
                description: "The address file consists of 11 cards and a piece of paper measuring approximately 14.8 × 10.5 cm (postcards, printed messages, an invitation, a menu), on the back of which Benjamin wrote down names, addresses and telephone numbers."
            },
            WBA_272: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 6.8 × 10.5 cm.",
                    p2: "Page dimensions (width × height): 9.4 × 11.7 cm.",
                    p3: "Page dimensions (width × height): 10.4 × 13.5 cm."
                }
            },
            WBA_290: {
                pageDescriptions: {
                    p3: "Page dimensions (width × height): 13.2 × 17.2 cm."
                }
            },
            WBA_359: {
                description: "Page dimensions (width × height): 11.6 × 8 cm."
            },
            WBA_363: {
                description: `Page dimensions (width × height, set): 19.8-20.9 × 27.2-27.3 cm.`,
                pageDescriptions: {
                    p033: "Page dimensions (width × height, current page): 14 × 22.4 cm.",
                    p034: "Page dimensions (width × height, current page): 14 × 22.4 cm.",
                    p035: "Page dimensions (width × height, current page): 11.3 × 18 cm."
                }
            },
            WBA_369: {
                description: `Page width: 17.9 cm, page height: 20.9 cm.`
            },
            WBA_370: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 13.6 × 21.4 cm.",
                    p2: "Page dimensions (width × height): 13.5 × 20.8 cm.",
                    p3: "Page dimensions (width × height): 13.5 × 20.8 cm.",
                    p4: "Page dimensions (width × height): 13.5 × 20.8 cm.",
                    p5: "Page dimensions (width × height): 13.5 × 20.8 cm."
                }
            },
            WBA_371: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 12.9 × 17.2 cm.",
                    p2: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p3: "Page dimensions (width × height): 27 × 21 cm.",
                    p5: "Page dimensions (width × height): 10.5 × 13.7 cm.",
                    p6: "Page dimensions (width × height): 13.8 × 22.4 cm.",
                    p7: "Page dimensions (width × height): 13.8 × 22.4 cm.",
                    p8: "Page dimensions (width × height): 13.8 × 22.4 cm.",
                    p9: "Page dimensions (width × height): 13.6 × 21.1 cm.",
                    p10: "Page dimensions (width × height): 13.8 × 22.4 cm.",
                    p11: "Page dimensions (width × height): 13.5 × 9 cm.",
                    p12: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p14: "Page dimensions (width × height): 7.2 × 10.3 cm.",
                    p15: "Page dimensions (width × height): 7.2 × 10.3 cm.",
                    p16: "Page dimensions (width × height): 8 × 11.5 cm.",
                    p17: "Page dimensions (width × height): 13.5 × 20.8 cm.",
                    p18: "Page dimensions (width × height): 13.3 × 17.2 cm.",
                    p19: "Page dimensions (width × height): 13 × 17.2 cm.",
                    p20: "Page dimensions (width × height): 30.8 × 20.9 cm.",
                    p21: "Page dimensions (width × height): 30.8 × 20.9 cm."
                }
            },
            WBA_372: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p2: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p3: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p4: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p5: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p6: "Page dimensions (width × height): 8 × 11.2 cm.",
                    p7: "Page dimensions (width × height): 13.6 × 21 cm",
                    p8: "Page dimensions (width × height): 12.8 × 17.2 cm",
                    p10: "Page dimensions (width × height): 10.4 × 14.8 cm",
                    p11: "Page dimensions (width × height): 13.4 × 20.9 cm.",
                    p12: "Page dimensions (width × height): 13.7 × 20.8 cm."
                }
            },
            WBA_373: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 15.5 × 14.5 cm.",
                    p2: "Page dimensions (width × height): 17.2 × 26.6 cm.",
                    p3: "Page dimensions (width × height): 10.4 × 14.4 cm.",
                    p5: "Page dimensions (width × height): 10.6 × 13.7 cm.",
                    p4: "Page dimensions (width × height): 12.8 × 17.2 cm."
                }
            },
            WBA_398: {
                description: `The brown leather-bound volume is printed on 60 highly translucent beige pages in 10 × 15.5 cm format containing the text “Berliner Chronik”.
                    The pages are tightly printed with black ink, generally only on the front side, and are heavily faded in parts. The leather-bound volume also contains
                    the text “Spanien 1932”, which begins on the last page of the overturned book so that both texts run into the middle of the volume.<br/><br/>Page
                    dimensions: height with edge overlap 17.2 cm, height without edge overlap 15.5 cm, width with edge overlap 11.3 cm, width without edge overlap 10 cm.`
            },
            WBA_401: {
                pageDescriptions: {
                    p18: "Page dimensions (width × height): 9 × 12 cm."
                }
            },
            WBA_433: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 10.5 × 13.6 cm."
                }
            },
            WBA_524: {
                pageDescriptions: {
                    p29: "Page dimensions (width × height): 13.6 × 21 cm."
                }
            },
            WBA_973: {
                pageDescriptions: {
                    p1: "Page dimensions (width × height): 13.6 × 21.5 cm."
                }
            },
            WBA_BK_Stefan: {
                description: "Page dimensions (width × height, set): 19.6–21 × 27.2-27.4 cm.",
                pageDescriptions: {
                    p04: "Page dimensions (width × height, current page): 14.2 × 27.2 cm.",
                    p15: "Page dimensions (width × height, current page): 17.7 × 27.2 cm."
                }
            },
            metadata: {
                detailsReference: "Detailed information on the manuscript can be found in “Zur Edition” in the print edition.",
                metadata: "Metadata",
                notAvailable: "No metadata for the currently displayed page available"
            }
        },
        fr: {
            WBA_085: {
                pageDescriptions: {
                    p005: "Mesurage de la page (largeur × longueur): 14,4 × 22,4 cm."
                }
            },
            WBA_110: {
                pageDescriptions: {
                    p5: "Mesurage de la page (largeur × longueur): 13,6 × 10,5 cm."
                }
            },
            WBA_157: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 22 × 28,5 cm."
                }
            },
            WBA_206: {
                pageDescriptions: {
                    p2: "Mesurage de la page (largeur × longueur): 14,9 × 11,4 cm.",
                    p3: "Mesurage de la page (largeur × longueur): 13,6 × 10,5 cm."
                }
            },
            WBA_208: {
                description: "Mesurage de la page (largeur × longueur): 7,9 × 4,7 cm."
            },
            WBA_209: {
                description: "Le dossier d'adresses est composé de 11 cartes et d'un morceau de papier mesurant environ 14,8 × 10,5 cm (cartes postales, messages imprimés, une invitation, un menu), au dos duquel Benjamin a inscrit des noms, des adresses et des numéros de téléphone."
            },
            WBA_272: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 6,8 × 10,5 cm.",
                    p2: "Mesurage de la page (largeur × longueur): 9,4 × 11,7 cm.",
                    p3: "Mesurage de la page (largeur × longueur): 10,4 × 13,5 cm."
                }
            },
            WBA_290: {
                pageDescriptions: {
                    p3: "Mesurage de la page (largeur × longueur): 13,2 × 17,2 cm."
                }
            },
            WBA_359: {
                description: "Mesurage de la page (largeur × longueur): 11,6 × 8 cm."
            },
            WBA_363: {
                description: `Mesurage de la page (largeur × longueur, Konvolut): 19,8-20,9 × 27,2-27,3 cm.`,
                pageDescriptions: {
                    p033: "Mesurage de la page (largeur × longueur, page présente): 14 × 22,4 cm.",
                    p034: "Mesurage de la page (largeur × longueur, page présente): 14 × 22,4 cm.",
                    p035: "Mesurage de la page (largeur × longueur, page présente): 11,3 × 18 cm."
                }
            },
            WBA_369: {
                description: `Longueur du page: 20,9 cm, largeur du page: 17,9 cm.`
            },
            WBA_370: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 13,6 × 21,4 cm.",
                    p2: "Mesurage de la page (largeur × longueur): 13,5 × 20,8 cm.",
                    p3: "Mesurage de la page (largeur × longueur): 13,5 × 20,8 cm.",
                    p4: "Mesurage de la page (largeur × longueur): 13,5 × 20,8 cm.",
                    p5: "Mesurage de la page (largeur × longueur): 13,5 × 20,8 cm."
                }
            },
            WBA_371: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 12,9 × 17,2 cm.",
                    p2: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p3: "Mesurage de la page (largeur × longueur): 27 × 21 cm.",
                    p5: "Mesurage de la page (largeur × longueur): 10,5 × 13,7 cm.",
                    p6: "Mesurage de la page (largeur × longueur): 13,8 × 22,4 cm.",
                    p7: "Mesurage de la page (largeur × longueur): 13,8 × 22,4 cm.",
                    p8: "Mesurage de la page (largeur × longueur): 13,8 × 22,4 cm.",
                    p9: "Mesurage de la page (largeur × longueur): 13,6 × 21,1 cm.",
                    p10: "Mesurage de la page (largeur × longueur): 13,8 × 22,4 cm.",
                    p11: "Mesurage de la page (largeur × longueur): 13,5 × 9 cm.",
                    p12: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p14: "Mesurage de la page (largeur × longueur): 7,2 × 10,3 cm.",
                    p15: "Mesurage de la page (largeur × longueur): 7,2 × 10,3 cm.",
                    p16: "Mesurage de la page (largeur × longueur): 8 × 11,5 cm.",
                    p17: "Mesurage de la page (largeur × longueur): 13,5 × 20,8 cm.",
                    p18: "Mesurage de la page (largeur × longueur): 13,3 × 17,2 cm.",
                    p19: "Mesurage de la page (largeur × longueur): 13 × 17,2 cm.",
                    p20: "Mesurage de la page (largeur × longueur): 30,8 × 20,9 cm.",
                    p21: "Mesurage de la page (largeur × longueur): 30,8 × 20,9 cm."
                }
            },
            WBA_372: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p2: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p3: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p4: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p5: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p6: "Mesurage de la page (largeur × longueur): 8 × 11,2 cm.",
                    p7: "Mesurage de la page (largeur × longueur): 13,6 × 21 cm",
                    p8: "Mesurage de la page (largeur × longueur): 12,8 × 17,2 cm",
                    p10: "Mesurage de la page (largeur × longueur): 10,4 × 14,8 cm",
                    p11: "Mesurage de la page (largeur × longueur): 13,4 × 20,9 cm.",
                    p12: "Mesurage de la page (largeur × longueur): 13,7 × 20,8 cm."
                }
            },
            WBA_373: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 15,5 × 14,5 cm.",
                    p2: "Mesurage de la page (largeur × longueur): 17,2 × 26,6 cm.",
                    p3: "Mesurage de la page (largeur × longueur): 10,4 × 14,4 cm.",
                    p5: "Mesurage de la page (largeur × longueur): 10,6 × 13,7 cm.",
                    p4: "Mesurage de la page (largeur × longueur): 12,8 × 17,2 cm."
                }
            },
            WBA_398: {
                description: `Le livret en cuir brun est constitué de 60 feuilles beiges hautement translucides au format 10 × 15,5 cm et porte l’inscription "Berliner Chronik".
                    Les feuilles sont – pour la plupart, seulement sur la face verso – densément couvertes d’écriture à l’encre noire, qui s'est fortement décolorée par
                    endroits. Le livret en cuir contient également le texte "Spanien 1932", qui a été commencé à la dernière page du livret, de sorte que les deux textes
                    se rencontrent au milieu du livret.<br/><br/>Mesurage des pages: longueur avec saillie du bord 17,2 cm, longueur sans saillie du bord 15,5 cm, largeur avec saillie du bord
                    11.3 cm, largeur sans saillie du bord 10 cm.`
            },
            WBA_401: {
                pageDescriptions: {
                    p18: "Mesurage de la page (largeur × longueur): 9 × 12 cm."
                }
            },
            WBA_433: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 10,5 × 13,6 cm."
                }
            },
            WBA_524: {
                pageDescriptions: {
                    p29: "Mesurage de la page (largeur × longueur): 13,6 × 21 cm."
                }
            },
            WBA_973: {
                pageDescriptions: {
                    p1: "Mesurage de la page (largeur × longueur): 13,6 × 21,5 cm."
                }
            },
            WBA_BK_Stefan: {
                description: "Mesurage de la page (largeur × longueur, Konvolut): 19,6–21 × 27,2-27,4 cm.",
                pageDescriptions: {
                    p04: "Mesurage de la page (largeur × longueur, page présente): 14,2 × 27,2 cm.",
                    p15: "Mesurage de la page (largeur × longueur, page présente): 17,7 × 27,2 cm."
                }
            },
            metadata: {
                detailsReference: "Vous trouverez des informations détaillées sur le support de transmission du texte dans l'édition imprimée (rubrique: \"Zur Edition\").",
                metadata: "Métadonnées",
                notAvailable: "Pas des métadonnées disponible"
            }
        }
    }
}
